import React from 'react';
import { Helmet } from 'react-helmet';
import LoginForm from '../LoginForm';

function LoginPage() {
  return (
    <div className="expand-wrap">
      <Helmet>
        <title>Member Sign In</title>
      </Helmet>
      <LoginForm />
    </div>
  );
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/containers/LoginPage/index.js